<template>
  <div class="subscription-expansion">
    <div class="header-wrapper">
      <SubHeader>
        <q-checkbox :value="!unSelected.length" @input="$emit('remove-subscriptions')" />
      </SubHeader>

      <SubHeader>
        <q-checkbox :value="false" @input="$emit('select-subscriptions')" />
      </SubHeader>
    </div>

    <transition-group name="flip-list" tag="div" class="subscriptions" mode="out-in">
      <div v-for="sub of selected" :key="sub.id" class="subscription selected" @click="toggle(sub)">
        <q-checkbox v-model="sub.selected" :val="sub.selected" />
        <span>{{ sub.name }}</span>
        <span>{{ sub.latest_period.name_reference }}</span>
        <span>{{ renderPeriod(sub.latest_period) }}</span>
      </div>

      <div
        v-for="(sub, index) of unSelected"
        :key="sub.id"
        :style="{ 'grid-row-start': index + 1 }"
        class="subscription unselected"
        @click="toggle(sub)"
      >
        <q-checkbox v-model="sub.selected" :val="sub.selected" />
        <span>{{ sub.name }}</span>
        <span>{{ sub.latest_period.name_reference }}</span>
        <span>{{ renderPeriod(sub.latest_period) }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
// Libraries
import moment from 'moment'

// Components
import SubHeader from './SubHeader'

export default {
  components: {
    SubHeader
  },

  props: {
    selected: Array,
    unSelected: Array
  },

  methods: {
    toggle(sub) {
      sub.selected = !sub.selected
    },

    renderPeriod({ start_date, end_date }) {
      const getLocalDate = date =>
        moment
          .tz(date, this.settings.timezone)
          .local()
          .format(this.settings.date_format)
      const localStartDate = getLocalDate(start_date)
      const localEndDate = end_date ? getLocalDate(end_date) : 'One time purchase'

      return `${localStartDate} - ${localEndDate}`
    }
  }
}
</script>

<style lang="stylus" scoped>
.subscription-expansion {
  > .header-wrapper {
    display grid
    grid-template-columns repeat(2, 1fr)
    gap 10px
  }
}

.subscriptions {
  display grid
  grid-template-columns 1fr 1fr
  gap 10px
  margin-top 5px

  > .subscription {
    display grid
    grid-template-columns 50px repeat(3, 1fr)
    align-items center
    gap 5px
    border 1px solid #ccc
    border-radius 5px
    background white

    > span {
      overflow hidden
      text-overflow ellipsis
    }

    :hover {
      cursor pointer
    }
  }

  > .selected {
    grid-column 1
  }

  > .unselected {
    grid-column 2
  }
}

.flip-list-move {
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  z-index 1
}
</style>
